import React from "react";
import {Button, ControlLabel, FormControl, FormGroup, Modal} from "react-bootstrap";
import MatGrid from "../../components/common/Mat/MatGrid";
import MatInput from "../../components/common/Mat/MatInput";
import ResponsibleSelect from "./ResponsibleSelect";

export default function CountryModalContainer({showNameModal, closeModal, onSave, name, setName, title, icon, responsible, setResponsible}) {

    let saveAndClose = () => {
        onSave();
        setName("");
        setResponsible(null)
        closeModal(true);
    }

    return (
        <>
            <Modal show={showNameModal} onHide={()=> closeModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Insert name of new {title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <br />
                    <MatGrid.Row>
                        <MatGrid.Col width="100%">
                            <MatInput
                                type="text"
                                icon={icon}
                                label={`${title} name`}
                                value={name}
                                onChange={(ev) => setName(ev.target.value)}
                            />
                        </MatGrid.Col>
                    </MatGrid.Row>
                    <MatGrid.Row>
                        <MatGrid.Col width="100%">
                            <ResponsibleSelect
                                default={responsible || "Select responsible person"}
                                onChange={(ev) => setResponsible(ev)}
                            />
                        </MatGrid.Col>
                    </MatGrid.Row>
                    <br />
                </Modal.Body>
                <Modal.Footer>
                    <Button className="pull-left" bsStyle="danger" onClick={()=> closeModal(false)}>Close</Button>
                    <Button className="pull-right"
                            bsStyle="primary"
                            onClick={()=> saveAndClose()}>Save</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
